"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACGradientCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helpers_1 = require("../utils/helpers");
var ACGradientCard = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = props === null || props === void 0 ? void 0 : props.context, state = _f.state, rootState = _f.rootState;
    var styles = {
        primary: {
            className: "primary",
            borderClassName: 'border-[#7DB0FE]',
        },
        info: {
            className: "blue-green",
            borderClassName: 'border-[#0D92C3]',
        },
        secondary: {
            className: "secondary",
            borderClassName: 'border-[#A9B0FF]',
        },
        success: {
            className: "success",
            borderClassName: 'border-[#6ACD7F]',
        },
        danger: {
            className: "danger",
            borderClassName: 'border-[#FF9999]',
        },
        yellow: {
            className: "yellow",
            borderClassName: 'border-[#FFB800]',
            textColor: 'text-white',
        },
        services_secondary: {
            className: "secondary",
            borderClassName: 'border-[#A9B0FF]',
            textColor: 'text-white',
        },
        services_primary: {
            className: "success",
            borderClassName: 'border-[#A9B0FF]',
            textColor: 'text-white',
        },
        services_violet: {
            className: "violet",
            borderClassName: 'border-[#A9B0FF]',
            textColor: 'text-white',
        },
    };
    var variant = (props === null || props === void 0 ? void 0 : props.variant) || (props === null || props === void 0 ? void 0 : props.color) || '';
    var variantClass = (_b = "apx-ui_gradient-card ".concat(((_a = styles === null || styles === void 0 ? void 0 : styles[variant]) === null || _a === void 0 ? void 0 : _a.className) || "")) === null || _b === void 0 ? void 0 : _b.trim();
    var icon = (props === null || props === void 0 ? void 0 : props.prefixIcon) || '';
    var iconClassName = (props === null || props === void 0 ? void 0 : props.prefixIconClassName) || '';
    state = (_c = state === null || state === void 0 ? void 0 : state.dynamic) === null || _c === void 0 ? void 0 : _c[rootState || ''];
    var _g = props || {}, labelSource = _g.suffixTextSource, name = _g.name, label = _g.suffixText;
    if (typeof (labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation) === 'string' &&
        ((_d = labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation) === null || _d === void 0 ? void 0 : _d.includes('@item'))) {
        var path = (_e = labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation) === null || _e === void 0 ? void 0 : _e.replace('@item.', '');
        var nestedValue_1 = helpers_1.Helper.getNestedValue(event, path);
        return nestedValue_1 || '';
    }
    var nestedValue = helpers_1.Helper.getNestedValue(state, (labelSource === null || labelSource === void 0 ? void 0 : labelSource.storedLocation) || '');
    var defaultLabel = (labelSource === null || labelSource === void 0 ? void 0 : labelSource.default) || '';
    nestedValue = helpers_1.Helper.getTransformedLabel({
        value: nestedValue,
        defaultLabel: defaultLabel,
    });
    var value = nestedValue || (state === null || state === void 0 ? void 0 : state[name]) || label || defaultLabel;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "".concat(variantClass, " ").concat((props === null || props === void 0 ? void 0 : props.className) || '', " ").concat((props === null || props === void 0 ? void 0 : props.active) ? 'active' : '', " ").concat((props === null || props === void 0 ? void 0 : props.clickable) === false ? "" : "clickable"), onClick: props === null || props === void 0 ? void 0 : props.onClick, children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex gap-4 justify-center items-center", children: [iconClassName && ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(icon, " ").concat(iconClassName || 'aci-dynamic-size size-32') })), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium ".concat(variant ? "text-white" : "", " ").concat((props === null || props === void 0 ? void 0 : props.titleClassName) || ''), children: (props === null || props === void 0 ? void 0 : props.title) || '' }), (props === null || props === void 0 ? void 0 : props.subtitle) && ((0, jsx_runtime_1.jsx)("span", { className: "text-xs ".concat(variant ? "text-white" : "", " ").concat((props === null || props === void 0 ? void 0 : props.subtitleClassName) || ''), children: props === null || props === void 0 ? void 0 : props.subtitle }))] })] }), (0, jsx_runtime_1.jsx)("p", { className: "text-[24px] font-medium ".concat(variant ? "text-white" : "", " ").concat(props === null || props === void 0 ? void 0 : props.suffixClassName), children: value })] }));
};
exports.ACGradientCard = ACGradientCard;
